Date.prototype.formatDate = function (format) {
  let date = this
  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  let monthnames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli','August','September','Oktober','November','Dezember']
  let daynames = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
  if (!format) {
    format = "MM/dd/yyyy"
  }
  if (format.indexOf("YYYY") > -1) {
    format = format.replace("YYYY", year.toString())
  } else if (format.indexOf("YY") > -1) {
    format = format.replace("YY", year.toString().substr(2, 2))
  }
  if (format.indexOf("MMMM") > -1) {
    format = format.replace("MMMM", monthnames[date.getMonth()])
  } else if (format.indexOf("MM") > -1) {
    format = format.replace("MM", month.toString().replace(/^(\d)$/, '0$1'))
  }
  format = format.replace("dd", daynames[date.getDay()])
  format = format.replace("DD", day.toString().replace(/^(\d)$/, '0$1'))
  if (format.indexOf("HH") > -1) {
    format = format.replace("HH", hours.toString().replace(/^(\d)$/, '0$1'))
  }
  if (format.indexOf("hh") > -1) {
    if (hours > 12) {
      hours -= 12
    }
    if (hours === 0) {
      hours = 12
    }
    format = format.replace("hh", hours.toString().replace(/^(\d)$/, '0$1'))
  }
  if (format.indexOf("mm") > -1) {
    format = format.replace("mm", minutes.toString().replace(/^(\d)$/, '0$1'))
  }
  if (format.indexOf("ss") > -1) {
    format = format.replace("ss", seconds.toString().replace(/^(\d)$/, '0$1'))
  }
  return format
}
Date.prototype.getWeekNumber = function () {
  let d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()))
  let dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  let yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1))
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
}
Date.prototype.toIsoString = function () {
  let tzo = -this.getTimezoneOffset()
  let dif = tzo >= 0 ? '+' : '-'
  let pad = function (num) {
    let norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }
  return this.getFullYear() +
      '-' + pad(this.getMonth() + 1) +
      '-' + pad(this.getDate()) +
      ' ' + pad(this.getUTCHours()) +
      ':' + pad(this.getUTCMinutes()) +
      ':' + pad(this.getUTCSeconds()) +
      dif + pad(tzo / 60) +
      ':' + pad(tzo % 60)
}
function convertDateForIos (date) {
  if (!date) return date
  if (date instanceof Date) return date
  const str = String(date)
  // Strip timezone suffix (Z, +HH:MM, -HH:MM) and split on any separator
  const cleaned = str.replace(/[TZ]/g, ' ').replace(/[+-]\d{2}:\d{2}$/, '').trim()
  if (cleaned.indexOf(' ') >= 0) {
    let arr = cleaned.split(/[- :]/)
    date = new Date(arr[0], arr[1]-1, arr[2], arr[3] || 0, arr[4] || 0, parseInt(arr[5]) || 0)
  }
  return date
}
